import { TRegularInfrastructureItem } from '../../../types/map';

export const getCurrentRouteItem = (item: TRegularInfrastructureItem | null, isObjectPoint: boolean) => {
  if (isObjectPoint) {
    return null;
  }

  return item;
};
